import { handleActions } from 'redux-actions';
import { HostPaymentPage, DropInElementOptions } from '@airwallex/airwallex-payment-elements';
export const REQUEST_ACTION = 'CHECKOUT/REQUEST/SET';

export type RequestType = HostPaymentPage & DropInElementOptions;

export const reducer = handleActions(
  {
    [REQUEST_ACTION]: (_, action) => ({
      ...action.payload,
    }),
  },
  {} as RequestType,
);

export default reducer;
